<mat-toolbar color="accent">Automation Preview</mat-toolbar>

<mat-dialog-content>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-4 rounded-md bg-white p-4 shadow-md">
      <pr-template-preview
        [template]="data.template"
        [context]="data.context"
        [type]="data.type"
      />
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button type="button" mat-stroked-button mat-dialog-close>Close</button>
  </pt-buttons-container>
</mat-dialog-actions>
